"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Creates a debounced function.
 *
 * @param {*} fn The function to call after timeout
 * @param {*} timeout The timeout in ms to debounce by. Defaults to 100ms.
 */
var debounce = exports.debounce = function debounce(fn) {
  var ms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

  var timeout = void 0;
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    clearTimeout(timeout);
    timeout = setTimeout(function () {
      return fn.apply(undefined, args);
    }, ms);
  };
};